import React from "react";
import * as Styles from "./styles/BottomNavigation";
import * as Button from "../../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import Icon from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { IconWrapper } from "../../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import useSiblingStepLink from "../../../../hooks/shared/actions/useSiblingStepLink";
import { useBnbSelector } from "../../../../redux/store";
import { getBnbPriceConfig } from "../../../../utils/settings/bnbFinanceSettingUtils";
import { showPrice } from "../../../../../../../common-deprecated/settings/utils/financeSettingUtilsCommon";
import { isPassiveSummary } from "../../../../utils/settings/bnbSettingUtils";

const BottomNavigation = (): JSX.Element | null => {
    const nextStepLink = useSiblingStepLink("next");
    const prevStepLink = useSiblingStepLink("prev");
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const priceConfig = useBnbSelector((state) =>
        getBnbPriceConfig(state.commonSettings, state.car.model.internalCode, state.navigation.step),
    );

    const passiveSummary = isPassiveSummary(commonSettings); // Hide back to customization button
    const showNextLink = nextStepLink && (!priceConfig.priceEnabled || !showPrice(commonSettings)); // show when price is disabled (financetoggle panel is hiden in this case)
    const showPrevLink = prevStepLink && !passiveSummary;

    if (!showPrevLink && !showNextLink) return null;
    return (
        <Styles.Wrapper>
            {showPrevLink ? (
                <Button.Link as="a" href={prevStepLink.url} hasIcon large onClick={prevStepLink.go}>
                    <IconWrapper>
                        <Icon variant="arrowLeft" />
                    </IconWrapper>
                    {prevStepLink.label}
                </Button.Link>
            ) : (
                // empty div needed for flexbox
                <div />
            )}
            {showNextLink && (
                <Button.Primary as="a" href={nextStepLink?.url} onClick={nextStepLink?.go} mx={0}>
                    {nextStepLink?.label}
                </Button.Primary>
            )}
        </Styles.Wrapper>
    );
};

export default BottomNavigation;
